import { EVENT_ACTIONS } from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import { CATEGORIES, ACTIONS } from 'modules/app/services/ga/constants';
import GtagService from 'modules/app/services/ga/GtagService';

import {
  EVENTS_CATEGORY,
  EVENTS_INTERACTIONS,
  EVENTS_LABELS
} from '../../app/services/datahub/constants';

const gaEvents = {
  ACTIVATE: {
    category: CATEGORIES.CLUB_ADMIN_SETTINGS,
    where: ACTIONS.DRM_SETTINGS.ACTIVATE,
    label: 'Activate DRM'
  },
  DEACTIVATE: {
    category: CATEGORIES.CLUB_ADMIN_SETTINGS,
    where: ACTIONS.DRM_SETTINGS.DEACTIVATE,
    label: 'Deactivate DRM'
  },
  CONFIRM_ACTIVATE: {
    category: CATEGORIES.CLUB_ADMIN_SETTINGS,
    where: ACTIONS.DRM_SETTINGS.CONFIRM_ACTIVATE,
    label: 'Confirm activate DRM'
  },
  CONFIRM_DEACTIVATE: {
    category: CATEGORIES.CLUB_ADMIN_SETTINGS,
    where: ACTIONS.DRM_SETTINGS.CONFIRM_DEACTIVATE,
    label: 'Confirm deactivate DRM'
  }
};

const datahubEvents = {
  ACTIVATE: {
    category: EVENTS_CATEGORY.DRM_SETTINGS.ACTIVATE,
    action: EVENTS_INTERACTIONS.CLICK,
    label: EVENTS_LABELS.DRM_SETTINGS.ACTIVATE
  },
  DEACTIVATE: {
    category: EVENTS_CATEGORY.DRM_SETTINGS.DEACTIVATE,
    action: EVENTS_INTERACTIONS.CLICK,
    label: EVENTS_LABELS.DRM_SETTINGS.DEACTIVATE
  },
  CONFIRM_ACTIVATE: {
    category: EVENTS_CATEGORY.DRM_SETTINGS.CONFIRM_ACTIVATE,
    action: EVENTS_INTERACTIONS.CLICK,
    label: EVENTS_LABELS.DRM_SETTINGS.CONFIRM_ACTIVATE
  },
  CONFIRM_DEACTIVATE: {
    category: EVENTS_CATEGORY.DRM_SETTINGS.CONFIRM_DEACTIVATE,
    action: EVENTS_INTERACTIONS.CLICK,
    label: EVENTS_LABELS.DRM_SETTINGS.CONFIRM_DEACTIVATE
  }
};

class StreamingEvents {
  send(eventName) {
    const gaEvent = gaEvents[eventName];
    const datahubEvent = datahubEvents[eventName];

    GtagService.sendClick(gaEvent);
    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData(datahubEvent)
    });
  }

  sendActivateEvent() {
    this.send('ACTIVATE');
  }

  sendDeactivateEvent() {
    this.send('DEACTIVATE');
  }

  sendConfirmActivateEvent() {
    this.send('CONFIRM_ACTIVATE');
  }

  sendConfirmDeactivateEvent() {
    this.send('CONFIRM_DEACTIVATE');
  }
}

export default new StreamingEvents();
